<template>
  <component
    :is="as"
    :class="[
      color && colors[color],
      offset && offsets[offset],
      weight && weights[weight],
      align && aligns[align],
      {
        [sizes[size]]: size,
      },
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
type HeadingType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
type HeadingSize =
  | 'xxxl'
  | 'xxl'
  | 'xl'
  | 'lg'
  | 'md'
  | 'sm'
  | 'xs'
  | '2xxl'
  | '3xxl'
  | '4xxl'
type TextWeight =
  | 'extralight'
  | 'light'
  | 'regular'
  | 'medium'
  | 'semibold'
  | 'bold'
type TextColors =
  | 'primary'
  | 'secondary'
  | 'black'
  | 'inherit'
  | 'white'
  | 'none'
type Offsets = 'bottom' | 'top' | 'left' | 'right'
type TextAlign = 'center' | 'left' | 'right'

withDefaults(
  defineProps<{
    as?: HeadingType
    size?: HeadingSize
    weight?: TextWeight
    color?: TextColors
    offset?: Offsets
    align?: TextAlign
  }>(),
  {
    as: 'h5',
    size: 'md',
  }
)

const sizes: Record<HeadingSize, string> = {
  xs: 'tw-text-xs',
  sm: 'tw-text-sm',
  md: 'tw-text-base',
  lg: 'tw-text-lg',
  xl: 'tw-text-xl',
  xxl: 'tw-text-2xl',
  xxxl: 'tw-text-3xl',
  '2xxl': 'tw-text-2xxl',
  '3xxl': 'tw-text-3xxl',
  '4xxl': 'tw-text-4xxl',
}

const weights: Record<TextWeight, string> = {
  extralight: 'tw-font-extralight',
  light: 'tw-font-light',
  regular: 'tw-font-normal',
  medium: 'tw-font-medium',
  semibold: 'tw-font-semibold',
  bold: 'tw-font-bold',
}

const colors: Record<TextColors, string> = {
  primary: 'tw-text-blue-500',
  secondary: 'tw-text-gray-b',
  black: 'tw-text-black',
  inherit: 'tw-text-inherit',
  white: 'tw-text-white',
  none: '',
}

const offsets: Record<Offsets, string> = {
  bottom: 'tw-mb-4',
  top: 'tw-mt-4',
  left: 'tw-ml-4',
  right: 'tw-mr-4',
}

const aligns: Record<TextAlign, string> = {
  left: 'tw-text-left',
  center: 'tw-text-center',
  right: 'tw-text-right',
}
</script>
